// Vue CLI embeds VUE_APP_* values into the bundle at build time.
// Default to disabled so a missing deployment value cannot expose Pro.
const isProEnabled = process.env.VUE_APP_PRO_ENABLED === "true"

export { isProEnabled }
